import type { MouseEventHandler } from 'react';
import type { IButtonProps } from 'components/common/Button';
import { ProjectType } from 'graphql/generated/graphql';

const projectTypes: readonly string[] = Object.values(ProjectType);

const isProjectType = (type: string | null): type is ProjectType =>
  type !== null && projectTypes.includes(type);

/**
 * The type for the project type mutation. The modal only submits one of its options and the start
 * page sends the planned project type (a project type apart from the land valuation, which opens
 * the modal), so this does not throw for the values the server sends.
 */
export const toProjectType = (type: string | null) => {
  if (!isProjectType(type)) {
    // The mutation was sent with it and the server rejected the variable.
    throw new TypeError(`Unknown project type: ${String(type)}`);
  }
  return type;
};

/**
 * The props of the submit button of a valuation form: before an estimation it opens the reminder
 * modal (with the click event as the modal data), afterwards it submits the form.
 */
export const getSubmitButtonProps = (
  estimationRequestCompleted: boolean,
  showModal: MouseEventHandler<HTMLButtonElement>,
  isSubmitting: boolean,
): IButtonProps => {
  if (!estimationRequestCompleted) {
    return { onClick: showModal, loading: false, disabled: false, type: 'button' };
  }
  return { loading: isSubmitting, disabled: isSubmitting, type: 'submit' };
};
